/**
 * @generated SignedSource<<f8f2a7493f77f085e49d32e1dc3525cf>>
 * @relayHash 6148088b78d90eaf05cd0977ae19acd2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 604973030b81bfa9d4dd7e063c820223a0011fed13ccf67b307ff0d32252fde9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type useOnAttemptToUpgradeQuery$variables = Record<PropertyKey, never>;
export type useOnAttemptToUpgradeQuery$data = {
  readonly confluence_tenantContext: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
  } | null | undefined;
};
export type useOnAttemptToUpgradeQuery = {
  response: useOnAttemptToUpgradeQuery$data;
  variables: useOnAttemptToUpgradeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "604973030b81bfa9d4dd7e063c820223a0011fed13ccf67b307ff0d32252fde9",
    "metadata": {},
    "name": "useOnAttemptToUpgradeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4018515a426e70ae3f06c918773853cf";

export default node;
